var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.208,
    height: 30,
    viewBox: "0 0 39.208 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_70",
    "data-name": "Rect\\xE1ngulo 70",
    width: 39.208,
    height: 30,
    fill: "#20164d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_46",
    "data-name": "Grupo 46",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_45",
    "data-name": "Grupo 45",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_176",
    "data-name": "Trazado 176",
    d: "M27.346,11.727a.959.959,0,0,1-.9-.909,1.019,1.019,0,0,1,.789-1.158l5-.711a.94.94,0,0,1,1.014.9,1.019,1.019,0,0,1-.79,1.157l-5,.711a.724.724,0,0,1-.114.009",
    transform: "translate(5.955 2.014)",
    fill: "#20164d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_177",
    "data-name": "Trazado 177",
    d: "M26.778,8.721a.881.881,0,0,1-.755-.458,1.13,1.13,0,0,1,.246-1.44l4.084-3.135a.841.841,0,0,1,1.261.282,1.13,1.13,0,0,1-.246,1.44L27.284,8.544a.831.831,0,0,1-.506.176",
    transform: "translate(5.827 0.791)",
    fill: "#20164d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_178",
    "data-name": "Trazado 178",
    d: "M32.062,17.478a.822.822,0,0,1-.322-.067L27.2,15.446a1.088,1.088,0,0,1-.528-1.338.878.878,0,0,1,1.171-.6l4.543,1.964a1.087,1.087,0,0,1,.528,1.338.923.923,0,0,1-.85.67",
    transform: "translate(5.994 3.026)",
    fill: "#20164d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_179",
    "data-name": "Trazado 179",
    d: "M0,12.9A5.03,5.03,0,0,1,4.439,9.207c.229-.021.484-.32.632-.55A3.76,3.76,0,0,1,8.518,6.9c2.1.013,4.2,0,6.3,0a10.11,10.11,0,0,0,7.72-3.278,5.24,5.24,0,0,0,.908-1.389A3.55,3.55,0,0,1,27.362.064,3.438,3.438,0,0,1,30.13,3.443q.048,10.434,0,20.866a3.37,3.37,0,0,1-2.7,3.291,3.278,3.278,0,0,1-3.808-1.856,7.369,7.369,0,0,0-3.706-3.7,9.77,9.77,0,0,0-6.047-1.2c0,1.742.059,3.439-.026,5.128a5.951,5.951,0,0,1-.572,2.375,3.313,3.313,0,0,1-3.6,1.576,3.251,3.251,0,0,1-2.639-2.756c-.17-1.822-.146-3.665-.156-5.5a2.2,2.2,0,0,0-.762-1.616,11.216,11.216,0,0,0-3.487-2.186C1.55,17.31.863,15.988,0,15V12.9M23.146,6.817c-2.129.762-4.277,1.5-6.393,2.322a1.239,1.239,0,0,0-.578.948c-.049,2.487-.012,4.977-.037,7.464-.006.68.174,1.07.924,1.115a4.257,4.257,0,0,1,1.4.3c1.573.674,3.126,1.4,4.685,2.107ZM13.8,9.224c-1.821,0-3.554.025-5.287-.009a1.412,1.412,0,0,0-1.634,1.573c-.025,2.05-.082,4.1.048,6.145.034.521.685,1.4,1.109,1.431,1.889.157,3.8.067,5.765.067Zm14.023,4.607q0-4.924,0-9.846c0-.8-.072-1.577-1.092-1.6-1.09-.028-1.226.783-1.228,1.631q0,9.847,0,19.692c0,.8.142,1.589,1.119,1.612,1.057.027,1.209-.765,1.206-1.639-.015-3.282-.006-6.565-.006-9.846M9.24,20.822c0,1.964-.069,3.83.054,5.685.026.4.7.975,1.144,1.052.3.051,1.019-.621,1.04-1,.11-1.894.05-3.8.05-5.738ZM4.516,11.68a2.106,2.106,0,0,0-2.18,2.253,1.954,1.954,0,0,0,2.18,2Z",
    transform: "translate(0 0)",
    fill: "#20164d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.e56cbe7fac22d024942fa69ad9f18d3d.svg";
export { ForwardRef as ReactComponent };